import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ListChecksIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireFeatureFlag,
  requirePermission,
} from '../route';
import { TasksQueuePage } from './TasksQueuePage';
import { tasksQueueSearchSchema } from './taskQueueSearch';

/**
 * Tasks queue — the URL-parameterized work queue over `core_tasks`
 * (`?type=<key>&status=…`). Gated by `tasks-enabled` plus Read on tasks.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/tasks',
  staticData: {
    app: {
      nav: {
        label: msg('Tasks', {
          context: 'sidebar nav label, Overview section',
        }),
        icon: <ListChecksIcon className="h-4 w-4" />,
        group: 'Overview',
        order: 6,
        groupOrder: 1,
      },
      access: {
        featureFlag: 'tasks-enabled',
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Task }],
      },
    },
  },
  component: TasksQueuePage,
  validateSearch: tasksQueueSearchSchema,
  loader: () => ({
    crumb: msg('Tasks', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireFeatureFlag('tasks-enabled');
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Task,
    });
  },
});
